export const SET_CURRENT_ROBOT = 'SET_CURRENT_ROBOT';

export const setCurrentRobot = (id) => ({
  type: SET_CURRENT_ROBOT,
  payload: {
    currentRobotId: id
  },
});
